import * as React from 'react';
import { Textarea } from 'ui';
import { ExternalUrlAdminTranslation } from 'app/area/external-urls-administration/constants';
import { ExternalUrlFormIds } from 'app/area/external-urls-administration/form/constants';
import { ValidationProps } from 'ui/common/validation';

interface ExternalUrlTemplateProps {
  value: string;
  readOnly: boolean;
  validation: ValidationProps;
  translation: ExternalUrlAdminTranslation;
  onChange: (urlTemplate: string) => void;
}

export const ExternalUrlTemplate = ({
  value, readOnly, validation, translation, onChange
}: ExternalUrlTemplateProps) =>
  <Textarea
    className={undefined}
    label={{ text: translation.column_url_template, required: !readOnly }}
    componentId={ExternalUrlFormIds.urlTemplate}
    onChange={onChange}
    value={value}
    validation={validation}
    readOnly={readOnly}
    maxLength={4000} />;
